module.exports = {
    'es.rent': {
        title: 'Selecciona la fecha de tu reserva',
        pickDay: 'Día de recogida del equipo',
        returnDay: 'Día de entrega del equipo',
        pickTime: 'Hora de recogida',
        returnTime: 'Hora de entrega',
        accept: 'Aceptar',
        cancel: 'Cancelar'
    },
    'es.tours': {
        title: 'Selecciona la fecha de tu Excursión',
        pickDay: 'Día de la excursión',
        pickpoint: 'Lugar donde estás alojado en Valencia'
    },
    'en.rent': {
        title: 'Select the date of your reservation',
        pickDay: 'Team pick-up day',
        returnDay: 'Team delivery day',
        pickTime: 'Pick up time',
        returnTime: 'Delivery time',
        accept: 'Accept',
        cancel: 'Cancel'
    },
    'en.tours': {
        title: 'Select the date of your tour',
        pickDay: 'Day of the excursion',
        pickpoint: 'Where you are staying in Valencia'
    },
    'fr.rent': {
        title: 'Sélectionnez la date de votre réservation',
        pickDay: 'Journée de collecte des équipes',
        returnDay: 'Jour de livraison de l\'équipe',
        pickTime: 'Temps de collecte',
        returnTime: 'Délai de livraison',
        accept: 'Accepter',
        cancel: 'Annuler'
    },
    'fr.tours': {
        title: 'Sélectionnez la date de votre excursion',
        pickDay: 'Jour de l\'excursion',
        pickpoint: 'Où êtes-vous à Valence?'
    }
};



// WEBPACK FOOTER //
// ./src/settings/Translations.js